'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import { Media } from "@/components/Media";
import { CMSLink } from "@/components/Link";
import Spotlight, { SpotlightCard } from "./Spotlight";
import FramerReveal from "@/components/framer-reveal-component";
import { ChevronLeft, ChevronRight } from 'lucide-react';
export const Layout396Block = t0 => {
  const $ = _c(21);
  const {
    heading,
    description,
    tagline,
    features,
    locale,
    theme
  } = t0;
  let t1;
  if ($[0] !== tagline) {
    t1 = <p className="mb-3 font-semibold md:mb-4 tagline">{tagline}</p>;
    $[0] = tagline;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== heading) {
    t2 = <h1 className="mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl">{heading}</h1>;
    $[2] = heading;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== description) {
    t3 = <p className="md:text-md">{description}</p>;
    $[4] = description;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t1 || $[7] !== t2 || $[8] !== t3) {
    t4 = <div className="mx-auto mb-12 w-full max-w-lg text-center md:mb-18 lg:mb-20"><FramerReveal>{t1}{t2}{t3}</FramerReveal></div>;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== features || $[11] !== locale) {
    t5 = features?.map((feature, index) => <FramerReveal key={`feature-${index}`} delay={0.1 + index * 0.1}><FeatureSection index={index} {...feature} locale={locale} /></FramerReveal>);
    $[10] = features;
    $[11] = locale;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t5) {
    t6 = <Spotlight className="mx-auto grid gap-6 lg:grid-cols-3 items-start group">{t5}</Spotlight>;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t4 || $[16] !== t6) {
    t7 = <div className="container">{t4}                    {t6}</div>;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7 || $[19] !== theme) {
    t8 = <section className="bg-background md:px-[5%] px-[1%] py-16 md:py-24 lg:py-28" data-theme={theme}>{t7}</section>;
    $[18] = t7;
    $[19] = theme;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  return t8;
};
const FeatureSection = t0 => {
  const $ = _c(26);
  let featureSection;
  let index;
  let locale;
  if ($[0] !== t0) {
    ({
      locale,
      index,
      ...featureSection
    } = t0);
    $[0] = t0;
    $[1] = featureSection;
    $[2] = index;
    $[3] = locale;
  } else {
    featureSection = $[1];
    index = $[2];
    locale = $[3];
  }
  const t1 = 0.1 + index * 0.1;
  let t2;
  if ($[4] !== featureSection.icon) {
    t2 = <div className="rb-5 mb-12 md:mb-16">{featureSection.icon.url?.endsWith(".svg") ? <div className="svgIcon svgIcon-medium" style={{
        width: "4rem",
        height: "4rem",
        maskImage: `url("${encodeURI(featureSection.icon?.url)}")`,
        WebkitMaskImage: `url("${encodeURI(featureSection.icon?.url)}")`,
        maskRepeat: "no-repeat",
        maskSize: "contain",
        backgroundColor: "var(--accent)"
      }} /> : <Media resource={featureSection.icon} imgClassName="w-auto h-14" />}</div>;
    $[4] = featureSection.icon;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== featureSection.tagline) {
    t3 = featureSection?.tagline && <p className="tagline text-xs mb-3">{featureSection.tagline}</p>;
    $[6] = featureSection.tagline;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== featureSection.heading) {
    t4 = <h2 className="mb-3 text-xl font-bold md:mb-4 md:text-2xl md:leading-[1.3] lg:text-3xl">{featureSection.heading}</h2>;
    $[8] = featureSection.heading;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== featureSection.description) {
    t5 = <p>{featureSection.description}</p>;
    $[10] = featureSection.description;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3 || $[15] !== t4 || $[16] !== t5) {
    t6 = <div className="item"><FramerReveal delay={t1}>{t2}{t3}{t4}{t5}</FramerReveal></div>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== featureSection.buttons || $[19] !== locale) {
    t7 = featureSection.buttons?.map((button, index_0) => <React.Fragment key={`button-${index_0}`}><CMSLink {...button.link} style="link" className="items-center">{locale === "ar" ? <ChevronLeft className="ms-2" /> : <ChevronRight className="ms-2" />}</CMSLink></React.Fragment>);
    $[18] = featureSection.buttons;
    $[19] = locale;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t7) {
    t8 = <div className="mt-5 md:mt-6">                    {t7}</div>;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t6 || $[24] !== t8) {
    t9 = <SpotlightCard><div className="relative h-full bg-card p-6 pb-8 rounded-xl z-20 overflow-hidden"><div className="flex flex-col justify-between h-full">{t6}{t8}</div></div></SpotlightCard>;
    $[23] = t6;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
};